import { render } from "./App.vue?vue&type=template&id=3ff864c2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/styles/noir-shell.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=3ff864c2&lang=css"

import exportComponent from "../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__